export default __webpack_public_path__ + "static/planet2-55078cf3e0478c8c440b9e1f34104a15.png";